/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CriarEspecialidadeDto,
  DefinirAtivoEspecialidadeDto,
  EspecialidadeDiscussaoResponse,
  ListaDeEspecialidadesResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getEspecialidadesDiscussaoAdminControllerListarUrl = () => {




  return `/v1/admin/especialidades-discussao`
}

/**
 * @summary Lista o catálogo global de especialidades de discussão
 */
export const especialidadesDiscussaoAdminControllerListar = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeEspecialidadesResponse> => {

  return httpClient<ListaDeEspecialidadesResponse>(getEspecialidadesDiscussaoAdminControllerListarUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEspecialidadesDiscussaoAdminControllerListarQueryKey = () => {
    return [
    `/v1/admin/especialidades-discussao`
    ] as const;
    }


export const getEspecialidadesDiscussaoAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEspecialidadesDiscussaoAdminControllerListarQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>> = ({ signal }) => especialidadesDiscussaoAdminControllerListar({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EspecialidadesDiscussaoAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>>
export type EspecialidadesDiscussaoAdminControllerListarQueryError = unknown


export function useEspecialidadesDiscussaoAdminControllerListar<TData = Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEspecialidadesDiscussaoAdminControllerListar<TData = Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEspecialidadesDiscussaoAdminControllerListar<TData = Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o catálogo global de especialidades de discussão
 */

export function useEspecialidadesDiscussaoAdminControllerListar<TData = Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEspecialidadesDiscussaoAdminControllerListarQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEspecialidadesDiscussaoAdminControllerCriarUrl = () => {




  return `/v1/admin/especialidades-discussao`
}

/**
 * @summary Cria uma especialidade nova. Idempotente por nome — repetir devolve a existente.
 */
export const especialidadesDiscussaoAdminControllerCriar = async (criarEspecialidadeDto: CriarEspecialidadeDto, options?: Parameters<typeof httpClient>[1]): Promise<EspecialidadeDiscussaoResponse> => {

  return httpClient<EspecialidadeDiscussaoResponse>(getEspecialidadesDiscussaoAdminControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarEspecialidadeDto)
  }
);}





export const getEspecialidadesDiscussaoAdminControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerCriar>>, TError,{data: CriarEspecialidadeDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerCriar>>, TError,{data: CriarEspecialidadeDto}, TContext> => {

const mutationKey = ['especialidadesDiscussaoAdminControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerCriar>>, {data: CriarEspecialidadeDto}> = (props) => {
          const {data} = props ?? {};

          return  especialidadesDiscussaoAdminControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EspecialidadesDiscussaoAdminControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerCriar>>>
    export type EspecialidadesDiscussaoAdminControllerCriarMutationBody = CriarEspecialidadeDto
    export type EspecialidadesDiscussaoAdminControllerCriarMutationError = unknown

    /**
 * @summary Cria uma especialidade nova. Idempotente por nome — repetir devolve a existente.
 */
export const useEspecialidadesDiscussaoAdminControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerCriar>>, TError,{data: CriarEspecialidadeDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerCriar>>,
        TError,
        {data: CriarEspecialidadeDto},
        TContext
      > => {
      return useMutation(getEspecialidadesDiscussaoAdminControllerCriarMutationOptions(options), queryClient);
    }
    export const getEspecialidadesDiscussaoAdminControllerDefinirAtivoUrl = (id: string,) => {




  return `/v1/admin/especialidades-discussao/${id}/ativo`
}

/**
 * @summary Ativa ou desativa. É o "remover" — discussões antigas continuam apontando pro id.
 */
export const especialidadesDiscussaoAdminControllerDefinirAtivo = async (id: string,
    definirAtivoEspecialidadeDto: DefinirAtivoEspecialidadeDto, options?: Parameters<typeof httpClient>[1]): Promise<EspecialidadeDiscussaoResponse> => {

  return httpClient<EspecialidadeDiscussaoResponse>(getEspecialidadesDiscussaoAdminControllerDefinirAtivoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoEspecialidadeDto)
  }
);}





export const getEspecialidadesDiscussaoAdminControllerDefinirAtivoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoEspecialidadeDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoEspecialidadeDto}, TContext> => {

const mutationKey = ['especialidadesDiscussaoAdminControllerDefinirAtivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerDefinirAtivo>>, {id: string;data: DefinirAtivoEspecialidadeDto}> = (props) => {
          const {id,data} = props ?? {};

          return  especialidadesDiscussaoAdminControllerDefinirAtivo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EspecialidadesDiscussaoAdminControllerDefinirAtivoMutationResult = NonNullable<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerDefinirAtivo>>>
    export type EspecialidadesDiscussaoAdminControllerDefinirAtivoMutationBody = DefinirAtivoEspecialidadeDto
    export type EspecialidadesDiscussaoAdminControllerDefinirAtivoMutationError = unknown

    /**
 * @summary Ativa ou desativa. É o "remover" — discussões antigas continuam apontando pro id.
 */
export const useEspecialidadesDiscussaoAdminControllerDefinirAtivo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoEspecialidadeDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof especialidadesDiscussaoAdminControllerDefinirAtivo>>,
        TError,
        {id: string;data: DefinirAtivoEspecialidadeDto},
        TContext
      > => {
      return useMutation(getEspecialidadesDiscussaoAdminControllerDefinirAtivoMutationOptions(options), queryClient);
    }
